import type { TokenName } from '@shared/constants/wallets';

import { FormToggleButtonRadioGroup } from '@ui/uikit/components/common/FormToggleButtonRadioGroup';

import { WEB3_RAFFLE_SUPPORTED_TOKENS } from '../../../model/web3Raffle/supportedTokens';

const options = WEB3_RAFFLE_SUPPORTED_TOKENS.map((token) => ({
  label: token,
  value: token,
}));

type Props = {
  onChange: (option: TokenName) => void;
  selectedToken: TokenName;
};

export const TokenTabs = ({ onChange, selectedToken }: Props) => {
  return (
    <FormToggleButtonRadioGroup
      className="w-full md:w-auto bg-base-bg-secondary text-base-text-tertiary rounded-lg"
      options={options}
      value={selectedToken}
      onValueChange={(value: TokenName) => onChange(value)}
    />
  );
};
